import { format } from "date-fns";

export const formatDate = (date) => format(date, "yyyy-MM-dd");
export const extractDate = (isoString) => isoString?.split("T")[0];
export const formatDatePtBr = (date) => {
  const [ano, mes, dia] = extractDate(new Date(date).toISOString()).split("-");
  return `${dia}/${mes}/${ano}`;
};
